import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Textarea } from '../ui/textarea';
import { Label } from '../ui/label';
import { ChevronDown, ChevronUp } from 'lucide-react';

function TermsSection(props) {
  const { formData, handleInputChange } = props;
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Card>
      <CardHeader 
        className="cursor-pointer hover:bg-gray-50"
        onClick={toggleOpen}
      >
        <CardTitle className="flex items-center justify-between text-base">
          <span>Quote Terms & Conditions</span>
          {isOpen ? (
            <ChevronUp className="w-5 h-5" />
          ) : (
            <ChevronDown className="w-5 h-5" />
          )}
        </CardTitle>
      </CardHeader>
      {isOpen ? (
        <CardContent className="space-y-4 pt-0">
          <div className="space-y-2">
            <Label>Inclusions</Label>
            <Textarea
              value={formData.inclusions || ''}
              onChange={(e) => handleInputChange('inclusions', e.target.value)}
              placeholder="What's included in the package..."
              rows={4}
            />
          </div>
          <div className="space-y-2">
            <Label>Exclusions</Label>
            <Textarea
              value={formData.exclusions || ''}
              onChange={(e) => handleInputChange('exclusions', e.target.value)}
              placeholder="What's not included..."
              rows={4}
            />
          </div>
          <div className="space-y-2">
            <Label>Payment Terms</Label>
            <Textarea
              value={formData.payment_terms || ''}
              onChange={(e) => handleInputChange('payment_terms', e.target.value)}
              placeholder="Payment schedule and terms..."
              rows={3}
            />
          </div>
          <div className="space-y-2">
            <Label>Cancellation Policy</Label>
            <Textarea
              value={formData.cancellation_policy || ''}
              onChange={(e) => handleInputChange('cancellation_policy', e.target.value)}
              placeholder="Cancellation charges and conditions..."
              rows={3}
            />
          </div>
          <div className="space-y-2">
            <Label>Terms and Conditions</Label>
            <Textarea
              value={formData.terms_conditions || ''}
              onChange={(e) => handleInputChange('terms_conditions', e.target.value)}
              placeholder="General terms and conditions..."
              rows={3}
            />
          </div>
        </CardContent>
      ) : null}
    </Card>
  );
}

export default TermsSection;
